import moment, { Moment } from "moment";
import React from "react";
import "./QuitDateSection.css";
import Background from "../../icons/quitdate_stage.png";
type Props = {
  daysSinceStart: number;
};
function getAsset(name) {
  return name;
}

const HOME = getAsset("home");

class QuitDateSection extends React.Component<Props> {
  checkDate(digit: number) {
    let im = [
      require("../../icons/letter_0.png"),
      require("../../icons/letter_0@2x.png"),
      require("../../icons/letter_0@3x.png"),
    ];
    switch (digit) {
      case 1:
        im = [
          require("../../icons/letter_1.png"),
          require("../../icons/letter_1@2x.png"),
          require("../../icons/letter_1@3x.png"),
        ];
        break;
      case 2:
        im = [
          require("../../icons/letter_2.png"),
          require("../../icons/letter_2@2x.png"),
          require("../../icons/letter_2@3x.png"),
        ];
        break;
      case 3:
        im = [
          require("../../icons/letter_3.png"),
          require("../../icons/letter_3@2x.png"),
          require("../../icons/letter_3@3x.png"),
        ];
        break;
      case 4:
        im = [
          require("../../icons/letter_4.png"),
          require("../../icons/letter_4@2x.png"),
          require("../../icons/letter_4@3x.png"),
        ];
        break;
      case 5:
        im = [
          require("../../icons/letter_5.png"),
          require("../../icons/letter_5@2x.png"),
          require("../../icons/letter_5@3x.png"),
        ];
        break;
      case 6:
        im = [
          require("../../icons/letter_6.png"),
          require("../../icons/letter_6@2x.png"),
          require("../../icons/letter_6@3x.png"),
        ];
        break;
      case 7:
        im = [
          require("../../icons/letter_7.png"),
          require("../../icons/letter_7@2x.png"),
          require("../../icons/letter_7@3x.png"),
        ];
        break;
      case 8:
        im = [
          require("../../icons/letter_8.png"),
          require("../../icons/letter_8@2x.png"),
          require("../../icons/letter_8@3x.png"),
        ];
        break;
      case 9:
        im = [
          require("../../icons/letter_9.png"),
          require("../../icons/letter_9@2x.png"),
          require("../../icons/letter_9@3x.png"),
        ];
        break;
    }
    return im;
  }

  render(): JSX.Element {
    const date: Moment = moment()
      .subtract(this.props.daysSinceStart, "days")
      .clone()
      .add(90, "days");

    const day = date.format("D");

    const firstDigit =
      day.length < 2
        ? this.checkDate(0)
        : this.checkDate(parseInt(day.charAt(0), 10));

    const secondDigit =
      day.length < 2
        ? this.checkDate(parseInt(day.charAt(0), 10))
        : this.checkDate(parseInt(day.charAt(1), 10));

    const background = getAsset("quitdate_stage");

    const year = date.format("YYYY");
    const yearFormatted = year.substr(0, 2);

    return (
      <div
        className="QuitDateSection"
        style={{ backgroundImage: `url(${Background})` }}
      >
        <div>
          <img src={firstDigit[0]} />
          <img src={secondDigit[0]} />
        </div>
        <div className="TITLE_2">{date.format("MMMM").toUpperCase()}</div>
        <div className="year">
          <div style={styles.yearText}>{yearFormatted}</div>
          <img src={require("../../icons/home.png")} style={styles.home} />
          <div style={styles.yearText}>{date.format("YY")}</div>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    height: 400,
    paddingTop: 112,
    width: "100%",

    backgroundPosition: "center",
  },

  day: {
    flexDirection: "row",
    marginTop: 32,
  },
  yearLogo: {
    flexDirection: "row",
    alignItems: "center",
  },
  yearText: {
    fontFamily: "Oswald-Bold",
    fontSize: 14,
    lineHeight: "16px",
    letterSpacing: 1.5,
    color: "white",
    paddingTop: "2px",
  },
  home: {
    marginHorizontal: 7,
    height: 20,
    width: 20,
  },
  backgroundStyle: { width: "100%" },
};

export default QuitDateSection;



// WEBPACK FOOTER //
// ./src/components/QuitDateSection/quitDateSection.tsx